<template>
    <div v-if="ready && current">

        <div v-if="mode != 'edit'" class="md-Layout md-size-100">
            <div v-if="title" class="md-layout md-layout-item md-size-100">
                <span class="md-title">{{title}}&nbsp;</span><span v-if="current.type" class="md-my-auto">({{current.type.title}})</span>
                <md-button class="md-icon-button md-dense md-my-auto ">
                    <md-icon class="md-m-0">info</md-icon><md-tooltip md-direction="right">{{current.description}}</md-tooltip>
                </md-button>
            </div>
            <label v-if="current">{{current.street}}</label><br>
            <label v-if="current.city" >{{current.city.name}}</label><br>
            <label v-if="current">{{current.zipCode}}</label> <label v-if="current.city.state">{{current.city.state.name}}</label> <label v-if="current.city.state.country">{{current.city.state.country.name}}</label>
        </div>

        <div v-if="mode == 'edit'" class="md-Layout md-size-100">
            <span v-if="title" class="md-title">{{title}}</span>
            <div class="md-layout-item md-layout">
                <div class="md-layout-item md-size-50 md-small-size-100 md-mr-3">
                    <md-field>
                        <label for="txtStreet">Rue</label>
                        <md-input name="txtStreet" v-model="current.street" type="text" :readonly="isReadOnly" />
                    </md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                    <md-field>
                        <label for="txtCity">Ville</label>
                        <md-input v-if="current.city" name="txtCity" v-model="current.city.name" type="text" :readonly="isReadOnly" />
                    </md-field>
                </div>
            </div>
            <div class="md-layout-item md-layout">
                <div class="md-layout-item md-small-size-100 md-mr-3">
                    <md-field>
                        <label for="txtZipCode">Code postal</label>
                        <md-input name="txtZipCode" v-model="current.zipCode" type="text" :readonly="isReadOnly" />
                    </md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                    <field-state v-if="current.city" title="Province" v-bind:stateId.sync="current.city.stateId" @md-changed="onStateChanged" :readonly="isReadOnly" />  <!--@update etc...-->
                </div>
            </div>

            <div class="md-layout-item md-layout">
                <div class="md-layout-item md-small-size-100 md-mr-3">
                    <field-type v-if="includeType != false" title="Type" v-bind:item.sync="current" property="typeId" @md-selected="onTypeSelected" :defaultValue="null" sourceURI="AddressTypes" :expand="false" :readonly="isReadOnly" />
                </div>
                <div class="md-layout-item md-small-size-100">
                    <field-desc v-if="includeDescription != false" title="Description" v-bind:item.sync="current" property="description" :readonly="isReadOnly" />
                </div>
            </div>
        </div>

    </div>
</template>
<style scoped>
    label {
        color: rgba(0, 0, 0, 0.54);
        font-size: 16px;
    }
 
</style>
<script>
    import field_state from '@/components/field-state.vue';

    import field_type from '@/components/field-select-wd.vue';
    import field_desc from '@/components/field-textarea-c.vue';

    export default {
        name: 'address1',
        mixins: [],
        props: {
            mode: String,
            title: String,
            item: Object,
            includeType: Boolean,
            includeDescription : Boolean,
            readonly: Boolean,
        },
        data: () => ({
            current: {},
        }),
        computed: {
            ready: function () {
                let val = false;

                if (this.item) {
                    this.current = this.item;
                    val = true;
                }

                return val;
            },
            isReadOnly: function() {
                return this.readonly;
            },

        },
        mounted: async function () {
            this.current = this.item;
        },
        methods: {
            onStateChanged: function (state) {
                if(this.current.city) {
                    this.current.city.state = state;
                    if(state) {
                        this.current.city.stateId  = state.id; 
                    }
                    else { this.current.city.stateId = 0 ;}
                }
            },
            onTypeSelected: function (e) {
                this.current.type = e;
            },

        },
        components: {
            'field-state': field_state,
            'field-type': field_type,
            'field-desc': field_desc,
        }
    }
</script>
